import { NgModule } from '@angular/core'
import { CustomCartSharedModule } from './cart-shared/custom-cart-shared.module'
import { CustomCartDetailsModule } from './custom-cart-details/custom-cart-details.module'
import { CartBaseModule } from '@spartacus/cart/base'

@NgModule({
  declarations: [],
  imports: [CartBaseModule, CustomCartDetailsModule, CustomCartSharedModule],
  providers: []
})
export class CustomCartModule {}
